import dayjs from 'dayjs';

import { TELEMETRY_EVENTS } from 'legacy-src/utility/telemetry';

const {
  teacherMarkComplete,
  teacherReopen,
  teacherDeleted,
  sppTeacherDeleted,
} = TELEMETRY_EVENTS;

export const sppMarkCompleteByTeacher = ({
  isComplete,
  sppTitle,
  sppId,
  assignmentId,
}) => ({
  event_type: isComplete ? teacherReopen : teacherMarkComplete,
  action_date: dayjs.utc().format(),
  spp_id: sppId,
  spp_title: sppTitle,
  assignment_id: assignmentId,
});

export const sppDeleteAssessment = ({
  spp_learnosity_reference,
  spp_title,
  spp_id,
  assignmentId,
}) => ({
  event_type: sppTeacherDeleted,
  spp_learnosity_reference: spp_learnosity_reference,
  spp_title: spp_title,
  spp_id: spp_id,
  assignmentId: assignmentId,
  action_date: dayjs.utc().format(),
});

export const deleteAssignmentByTeacher = ({
  title,
  assignmentId,
  section,
}) => ({
  event_type: teacherDeleted,
  assignment_title: title,
  assignmentId: assignmentId,
  action_date: dayjs.utc().format(),
  assignment_section: section,
});
